import { LinearProgress } from '@mui/joy';

import { useConfigureUsageLimit } from '../utils/usageLimitSetting.utils';
import { DataRetentionSetting } from './DataRetentionSettings';
import { WorkspaceUsageTable } from './UsageLimitSetting';

// Used only IA refactored UI
const ConfigureUsagePanelStandalone = () => {
  return (
    <div className="h-full overflow-y-auto">
      <ConfigureUsagePanel />
    </div>
  );
};

const ConfigureUsagePanel = () => {
  const configureUsageLimitProps = useConfigureUsageLimit({});

  if (configureUsageLimitProps.isLoading) {
    return <LinearProgress />;
  }

  return (
    <div className="relative flex h-full flex-col items-stretch gap-2">
      <DataRetentionSetting />
      <WorkspaceUsageTable />
    </div>
  );
};

export { ConfigureUsagePanel, ConfigureUsagePanelStandalone };
